import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import SlotShape from '../../../../../../shapes/Slot';
import styled from 'styled-components';
import FullTimeSlotGrid from './FullTimeSlotGrid';
import { colors } from '../../../../../../constants/colors';
import { fontSize, fontFamily } from '../../../../../../constants/text';
import { isEmptyArray } from '../../../../../../core/util/array';
import { getSlotSelectionProperties, getAvailableSlots } from './util';

export const INITIAL_SLICE = 8;

const ShowMoreOrLess = styled.div`
  color: ${colors.blueJayWay};
  font-size: ${fontSize.small};
  font-family: ${fontFamily.bold};
  letter-spacing: -0.13px;
  line-height: 16px;
  text-align: center;
  margin-top: 12px;
  margin-bottom: 24px;
  cursor: pointer;
`;

class ReducedTimeSlotGrid extends PureComponent {
  constructor(props) {
    super(props);

    if (isEmptyArray(props.selectedSlots)) {
      this.state = { sliceEnd: INITIAL_SLICE };
    } else {
      const maxSelectedAppointmentDate = Math.max(
        props.selectedSlots.map(slot => slot.appointmentDate)
      );

      const indexOfSlotCorrespondingToMaxSelectedAppointmentDate = props.slots.findIndex(
        slot => slot.appointmentDate === maxSelectedAppointmentDate
      );

      this.state = {
        sliceEnd: Math.max(INITIAL_SLICE, indexOfSlotCorrespondingToMaxSelectedAppointmentDate + 1),
      };
    }
  }

  getTimeSlotMenuCta = () => {
    const { sliceEnd } = this.state;

    if (this.props.slots.length <= INITIAL_SLICE) {
      return null;
    }

    if (sliceEnd >= this.props.slots.length) {
      return { onClick: this.handleClickLess, text: 'Fewer Times' };
    }

    return { onClick: this.handleClickMore, text: 'More Times' };
  };

  handleClickMore = () => {
    const { selectedSlots, handleSelectSlot, slots } = this.props;
    let sliceEnd;
    if (this.state.sliceEnd === INITIAL_SLICE) {
      sliceEnd = 24;
    } else {
      sliceEnd = this.state.sliceEnd + 24;
    }

    const handleUpdateGrid = () => {
      const slicedSlots = slots.slice(0, sliceEnd);
      handleSelectSlot(selectedSlots, getSlotSelectionProperties(slicedSlots));
    };

    this.setState({ sliceEnd }, handleUpdateGrid);
  };

  handleClickLess = () => {
    const { selectedSlots, handleSelectSlot, slots } = this.props;
    this.setState({ sliceEnd: INITIAL_SLICE });
    const slicedSlots = slots.slice(0, INITIAL_SLICE);
    handleSelectSlot(selectedSlots, getSlotSelectionProperties(slicedSlots));
  };

  render() {
    const {
      slots,
      timeZone,
      className,
      handleSelectSlot,
      selectedSlots,
      shouldSelectFirstSlotAsInitialValue,
      darkTheme,
    } = this.props;

    if (isEmptyArray(slots)) {
      return null;
    }

    const { sliceEnd } = this.state;
    const timeSlotMenu = this.getTimeSlotMenuCta();
    const slicedSlots = slots.slice(0, sliceEnd);

    return (
      <Fragment>
        <FullTimeSlotGrid
          selectedSlots={selectedSlots}
          handleSelectedSlot={handleSelectSlot}
          slots={slicedSlots}
          timeZone={timeZone}
          className={className}
          shouldSelectFirstSlotAsInitialValue={shouldSelectFirstSlotAsInitialValue}
          darkTheme={darkTheme}
        />
        <div>
          {timeSlotMenu && (
            <ShowMoreOrLess onClick={timeSlotMenu.onClick}>{timeSlotMenu.text}</ShowMoreOrLess>
          )}
        </div>
      </Fragment>
    );
  }
}

ReducedTimeSlotGrid.propTypes = {
  slots: PropTypes.arrayOf(SlotShape),
  timeZone: PropTypes.string,
  className: PropTypes.string,
  darkTheme: PropTypes.bool,
  handleSelectSlot: PropTypes.func,
  selectedSlots: PropTypes.arrayOf(SlotShape),
  shouldSelectFirstSlotAsInitialValue: PropTypes.bool,
  handleSlotGridChange: PropTypes.func,
};

export default ReducedTimeSlotGrid;
